 <div class="home-banner-video d-none d-md-flex">
   <div id="bg_container">
      <video class="d-none d-md-flex" id="bg" loop muted autoplay playsinline oncanplay="this.play()" onloadedmetadata="this.muted = true">
         <source src="../assets/images/sat-final-video.mp4" type="video/mp4">
      </video>

   </div>

   <div class="banner-overlap-text">
      <div class="container">
         <h1>Your Nordic Partner</h1>
         <p>for Transport & Logistics Solutions</p>
      </div>
   </div>
 </div>


 <div class="home-banner-image d-md-none">
   <div id="bg_img">
      <img class="video-replace-banner" id="bg-1" src="../assets/images/home-banner-for-mobile.jpg" alt="Home banner">
   </div>

   <div class="banner-overlap-text">
      <div class="container">
         <h1>Your Nordic Partner</h1>
         <p>for Transport & Logistics Solutions</p>
      </div>
   </div>
 </div>


